/* eslint no-undef: 0 */
import { LicensesRepository, ActivationCodesRepository } from 'common/repositories/index';

/**
 * Controller for the store page embedded in the dashboard
 * And new ConnectWeb Store Page
 */

angular.module('controllers')
    .controller('Store', ($scope, Util) => {

        const primeIds = Util.deepFind(CWCONFIG, 'features.primeOffer.primeIds') || [];
        const activationCodesRepo = ActivationCodesRepository.getAll();
        const licensesRepo = LicensesRepository.getAll();
        const userHasSubscriptions =
            activationCodesRepo.length > 0 || licensesRepo.length > 0;
        let userHasCustomPrimeSubscription = null;

        $scope.ShowPrimePage = false;
        $scope.showComparison = false;

        if (userHasSubscriptions) {

            let aps20shortestRuntime = 0;
            $scope.ShowPrimePage = true;

            // check if has Avira Prime (aps10 || aps20) and the runtime is 1,12 or 24
            activationCodesRepo.forEach((activationCode) => {

                const foundPrimeSubscription = primeIds.indexOf(activationCode.attributes.app) > -1;

                // show prime page if the user has any subscription other than aps20 with runtime 36
                if (foundPrimeSubscription &&
                    activationCode.attributes.app === 'aps20' &&
                    activationCode.attributes.runtime > aps20shortestRuntime) {

                    $scope.ShowPrimePage = true;
                    aps20shortestRuntime = activationCode.attributes.runtime;

                }

                // f the user has aps20 with runtime 36 show comparison page
                if (aps20shortestRuntime === 36) {

                    $scope.ShowPrimePage = false;
                    userHasCustomPrimeSubscription = true;

                }

            });

        } else {

            // show comparison page
            $scope.showComparison = true;

        }

        if (userHasCustomPrimeSubscription) {

            // $scope.ShowOODiskImagePage = true;
            // temporary solution - show comparison instead of O&O
            $scope.showComparison = true;

        }

        // $scope.$on('$destroy', () => {

        //     if ($rootScope.showPrimeTrialModal) {

        //         const trialModalClosed = sessionStorage.getItem('trialModalClosed');
        //         if (!trialModalClosed) {

        //             $state.go('root.dashboard.store.ltb', {
        //                 ltb: 'trial-modal',
        //                 resourceId: 'trial',
        //             });

        //         }

        //     }

        // });

    });



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/store/store.js